import React from 'react';
import ProjectCards from '../components/ProjectCards';
import { CaseStudyComponent } from '../components/CaseStudyComponent';

export default function InstacartRedesign() {
    return (
        <>
            <CaseStudyComponent slug="instacart" />
            <ProjectCards slug="instacart" />
        </>
    )
}
